
export interface INovelDataSimple
{
	uuid: string;
	id: string;
	title: string;
	authors: string[];
	cover: string;
	updated: number;
	content: string;
}
